/**
 * Shared top-of-page back control — one look everywhere (ghost sm + ArrowLeft).
 */

import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type BackLinkProps = {
  to: string;
  children: ReactNode;
  className?: string;
  "data-testid"?: string;
};

export function BackLink({ to, children, className, "data-testid": testId }: BackLinkProps) {
  return (
    <Button variant="ghost" size="sm" asChild className={cn("-ml-2", className)}>
      <Link to={to} data-testid={testId} data-back-link="">
        <ArrowLeft className="size-4" aria-hidden /> {children}
      </Link>
    </Button>
  );
}
